import { Modal } from "react-bootstrap";
import { X, InfoSquare, Whatsapp, Globe2 } from "react-bootstrap-icons";
import { useState } from "react";
import { checkSystemVersion } from "../../store/api/SystemSettingsAPI";
import { useEffect } from "react";
const pkg = require('../../../package.json');

const ModalAboutUs = (props) => {
    const [aboutLink, setAboutLink] = useState("#");
    const [appVersion, setAppVersion] = useState([]);
    const { show } = props
    useEffect(() => {
        if (show) {
            checkSystemVersion(setAppVersion);
            fetch(process.env.PUBLIC_URL + '/config.json'
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            )
                .then(res => res.json())
                .then(myJson => setAboutLink(myJson.AboutUsLink ?? "#"))
        }

    }, [show])

    return (
        <Modal show={props.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#838fe8' }}><span><InfoSquare color="white" size={20} />&nbsp;درباره نرم افزار</span><span onClick={() => props.setModalAboutUs(false)} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body style={{ textAlign: "center" }}>
                <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt='' />
                <p style={{ color: "blue", margin: "3px", fontSize: "12px" }}>نسخه نرم افزار: {pkg.version}</p>
                {appVersion && Array.isArray(appVersion) && appVersion.map((item, i) => <p style={{ color: "blue", margin: "3px", fontSize: "12px" }} key={i}>{item}</p>)}
                <a style={{ fontStyle: "italic", fontSize: "14px" }} href={aboutLink}><span id="aboutSoftwareLink"></span><Globe2 /></a>
                <p style={{ color: "black", fontStyle: "italic" }}><span id="aboutSoftwareWhatsApp" style={{ color: "#227b80" }}></span> <Whatsapp color="green" /></p>
            </Modal.Body>
            <Modal.Footer style={{ direction: "ltr" }}>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalAboutUs;